function renderInline(text) {
  // Bold **text**. Simple Markdown -> JSX.
  const parts = [];
  let remaining = text;
  let key = 0;
  const boldRe = /\*\*(.+?)\*\*/;
  while (remaining.length > 0) {
    const m = boldRe.exec(remaining);
    if (!m) {
      parts.push(<span key={key++}>{remaining}</span>);
      break;
    }
    if (m.index > 0) parts.push(<span key={key++}>{remaining.substring(0, m.index)}</span>);
    parts.push(
      <strong key={key++} className="font-semibold text-white">
        {m[1]}
      </strong>
    );
    remaining = remaining.substring(m.index + m[0].length);
  }
  return parts;
}

export function ChatBubble({ role, content }) {
  const isUser = role === "user";
  return (
    <div className={`flex ${isUser ? "justify-end" : "justify-start"}`}>
      <div
        data-testid={`chat-bubble-${role}`}
        className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed whitespace-pre-line ${
          isUser
            ? "bg-[#FF5A00] text-white rounded-br-md"
            : "bg-white/5 border border-white/10 text-neutral-200 rounded-bl-md"
        }`}
      >
        {content.split("\n").map((line, i) => (
          <p key={`${role}-line-${i}`} className={i > 0 ? "mt-2" : ""}>
            {renderInline(line)}
          </p>
        ))}
      </div>
    </div>
  );
}
